module.exports = ":host {\n  display: block; }\n"


//////////////////
// WEBPACK FOOTER
// ./apps/eyewatch/src/app/eyewatch/dashboards/pages/account/location-observation-chart/location-observation-chart.component.scss
// module id = ./apps/eyewatch/src/app/eyewatch/dashboards/pages/account/location-observation-chart/location-observation-chart.component.scss
// module chunks = main